import * as React from "react";
import { Button, styled } from "@mui/material";
import { useState } from "react";
import { UserLoginContainer } from "./userLoginContainer";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { SignUpForm } from "./signUpForm";

export const useQueryParams = () => new URLSearchParams(window.location.search);

//region [[ Styles ]]
const RosebudLoginContainer = styled(UserLoginContainer)({
  background: KahunColorMap.White,
  boxShadow: "#8082827d -1px 1px 7px 1px",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface SignUpWidgetProps {
  onSignUpComplete: () => void;
  onLoginClick?: () => void;
  hideLogo?: boolean;
  message?: string;
  children?: React.ReactNode;
  requireFullName?: boolean;
  // An identification to let us know from where the user had subscribed
  // (patient, agent, new england, clinic management?)
  platform?: string;
  customFields?: Record<string, string>;
  customClientData?: Record<string, string>;
  showWrapper?: boolean;
  requireSpecialty?: boolean;
}
//endregion [[ Props ]]

export const SignUpWidget = ({
  onSignUpComplete,
  requireFullName,
  platform,
  customFields,
  customClientData,
  ...props
}: SignUpWidgetProps) => {
  const [error, setError] = useState("");
  return (
    <RosebudLoginContainer
      error={error}
      message={props.message}
      hideLogo={props.hideLogo}
    >
      <SignUpForm
        onSignUpComplete={onSignUpComplete}
        onError={setError}
        requireFullName={requireFullName}
        requireSpecialty={props.requireSpecialty}
        platform={platform}
        customFields={customFields}
        customClientData={customClientData}
      >
        {props.children}
      </SignUpForm>
      {props.onLoginClick && (
        <span className={"navigation-link"}>
          Already have an account?
          <Button color={"primary"} onClick={props.onLoginClick}>
            Log In
          </Button>
        </span>
      )}
    </RosebudLoginContainer>
  );
};
